<!--<ngx-spinner bdColor="rgba(255,255,255,0.4)" size="small" color="none" type="none">-->
<!--  &lt;!&ndash;  <p style="font-size: 20px; color: white">{{ 'common.loading' | translate }}</p>&ndash;&gt;-->
<!--  <mat-spinner [mode]="'indeterminate'"></mat-spinner>-->
<!--</ngx-spinner>-->
<router-outlet></router-outlet>
<!-- <div dir="rtl" fxFlex>
  <mat-sidenav-container fxFill hasBackdrop="false" class="menu-state {{ menuSizeState }}">
    <mat-sidenav
      #sidenav
      opened="true"
      disableClose="true"
      mode="push"
      class="main-menu menu-style {{ menuSizeState }}"
      ngClass.gt-sm="has-border"
    >
      <nav>
        <mat-list>
          <div class="menu-brand" fxLayout="row" *ngIf="menuSizeState === 'large'">
            <div>
              <img src="/assets/images/logo.svg" width="120px" alt="Afaqy" />
            </div>
          
          </div>
          <div class="position-relative scrollable-container" [perfectScrollbar]>
            <a
              *ngIf="menuSizeState === 'small' || menuSizeState === 'hidden'"
              class="menu-button"
              href="javascript:void(0);"
              (click)="toggleMenuSize()"
            >
              <mat-icon>menu</mat-icon>
            </a>

            <mat-divider></mat-divider>
            <ng-container *ngFor="let item of menuItems.items; let i = index">
              <a *ngIf="!item?.children?.length" mat-list-item [routerLink]="item.url" routerLinkActive="active">
               
                <span *ngIf="menuSizeState === 'large'">{{ 'menu.' + item.title | translate }}</span>
              </a>
              <a
                class="text-decoration-none"
                mat-list-item
                *ngIf="item?.children?.length > 0 && menuSizeState === 'small'"
                [routerLink]="item.url"
                routerLinkActive="active"
              >

                <span *ngIf="menuSizeState === 'large'">{{ 'menu.' + item.title | translate }}</span>
              </a>
              <mat-accordion
                multi="true"
                displayMode="flat"
                *ngIf="item?.children?.length > 0 && menuSizeState !== 'small'"
              >
                <mat-expansion-panel class="mat-elevation-z0">
                  <mat-expansion-panel-header [class.active]="checkCurrentRoute(item)" fxLayout="row">
                   
                    <span *ngIf="menuSizeState === 'large'">{{ 'menu.' + item.title | translate }}</span>
                  </mat-expansion-panel-header>
                  <mat-list *ngFor="let child of item.children; let i = index">
                    <ng-container *ngIf="!child.hidden">
                      <a
                        class="menu-item"
                        mat-list-item
                        [routerLink]="child.url"
                        routerLinkActive="active"
                        [routerLinkActiveOptions]="{ exact: !!child.exact }"
                      ><span *ngIf="menuSizeState === 'large'">{{ 'menu.' + child.title | translate }}</span>
                      </a>
                    </ng-container>
                  </mat-list>
                </mat-expansion-panel>
              </mat-accordion>
              <mat-divider></mat-divider>
            </ng-container>
          </div>
        </mat-list>
      </nav>
    </mat-sidenav>
    <app-header
      [sidenav]="sidenav"
      [menuSizeState]="menuSizeState"
      (menuSizeStateEvent)="toggleMenuSize()"
      class="menu-state {{ menuSizeState }}"
    ></app-header>
    <div class="main-container menu-{{ menuSizeState }}">
      <div class="main-container-inner ">
        <router-outlet></router-outlet>
      </div>
    </div>
  </mat-sidenav-container>
</div> -->
